import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import { FormControlLabel, Checkbox, FormGroup } from '@material-ui/core';

const CustomCheckbox = ({ input, handleChange }) => (
    <GridItem xs={2} sm={1}>
        <FormControlLabel
            control={(
                <Checkbox
                    checked={input.active}
                    onChange={handleChange}
                    style={{
                        width: 16,
                        height: 16,
                        marginRight: '6px'
                    }}
                    disabled={input.disabled}
                />
            )}
            label={(
                <p style={{ fontSize: '0.75rem', margin: '4px 4px' }}>{input.label}</p>
            )}
        />
    </GridItem>
)

const MultiCheckbox = ({ inputs: allInputs, handleChange, containerStyle }) => {
    console.log('render');
    const inputs = _.cloneDeep(allInputs);
    const firstHalf = inputs.length > 12 ? inputs.splice(0, Math.ceil(inputs.length / 2)) : [];

    return (
        <GridContainer style={containerStyle}>
            {firstHalf.length ? (
                <GridItem container xs={12} justifyContent='center' alignItems='center'>
                    {firstHalf.map((input, i) => <CustomCheckbox input={input} handleChange={() => handleChange(i)} />)}
                </GridItem>
            ) : null}

            <GridItem container xs={12} justifyContent='center' alignItems='center'>
                {inputs.map((input, i) => <CustomCheckbox input={input} handleChange={() => handleChange(i + firstHalf.length)} />)}
            </GridItem>
        </GridContainer>
    );
}

export default MultiCheckbox;


// WEBPACK FOOTER //
// ./src/components/CustomInput/MultiCheckbox.jsx